<template>
    <v-flex xs12 mb-2 v-if="(cold_warm != salesLine.cold_warm)">
        <v-card>
            <v-layout xs12 v-for="textLine in salesLine.text_lines" :key=textLine.id>
                <v-flex xs3 text-xs-center>
                    {{ textLine.article }}
                </v-flex>
                <v-flex xs9>
                    <p :class="{ underline: textLine.qty_to_do, 'font-weight-bold': textLine.print_attribute }" >{{ ($store.state.user.settings.language == 'it' && textLine.name_it) ? textLine.name_it : textLine.name }}</p>
                    <p>{{ textLine.description }}</p>
                </v-flex>
            </v-layout>
            <v-card-actions v-if="salesLine.enabled && editable">
                <v-dialog
                    v-model="dialog"
                    scrollable
                    :overlay="false"
                    max-width="750px"
                    transition="dialog-transition"
                >
                    <v-btn slot="activator" flat small color="primary">gemacht {{ salesLine.qty_done }} von {{ salesLine.qty_to_do }} {{ salesLine.unity }}</v-btn>
                    <v-card v-if="TIMEENTRY_BY_SALESLINE">
                        <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                        >
                        {{ $vuetify.t('$vuetify.lobis.myEntriesForPosition') }}
                        </v-card-title>
                            <v-data-table
                                :headers="headers"
                                :items="TIMEENTRY_BY_SALESLINE(salesLine.id)"
                                hide-actions
                                class="elevation-1"
                                pagination.sync="pagination"
                                loading="true"
                            >
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.item.created_at | moment("DD.MM.Y") }}</td>
                                    <td>{{ props.item.qty }} {{ salesLine.unity }}</td>
                                </template>
                                <template slot="no-data">
                                    <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
                                </template>
                            </v-data-table>
                        <v-card-text>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                {{ $vuetify.t('$vuetify.lobis.go_back') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-spacer></v-spacer>
                <v-btn icon @click="addEntry(salesLine)">
                    <v-icon>add_circle</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import { TIMEENTRY_BY_SALESLINE } from '../../store/actions/timeEntry'
export default {
  props: {
    salesLine: null,
    editable: {
      type: Boolean,
      default: true
    },
    showColdWarm: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialog: false,
      headers: [
        {
          text: 'Datum',
          align: 'left',
          value: 'created_at'
        },
        { text: 'Menge', value: 'qty' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      TIMEENTRY_BY_SALESLINE
    ]),
    cold_warm () {
      return this.$store.state.user.settings.cold_warm.value * -1
    }
  },
  methods: {
    addEntry (line) {
      this.$router.push({name: 'timeentry', params: { line: line }})
      /* this.$swal
        .mixin({
          input: 'text',
          confirmButtonText: 'Weiter &rarr;',
          showCancelButton: true,
          cancelButtonText: 'Abbrechen'
        })
        .queue([
          {
            title: 'Fläche',
            text: 'Wie viele Quadratmeter hast du gemacht?',
            input: 'number',
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (value) {
                  console.log(value)
                  var data = {
                    salesLine: line,
                    quantity: value,
                    hours: null
                  }
                  this.$store.dispatch(TIMEENTRY_ADD, data)
                  resolve()
                } else {
                  resolve('Bitte eine Zahl eingeben')
                }
              })
            }
          }
        ])
        .then(result => {
          if (result.value) {
            this.$swal({
              title: 'Daten eingetragen',
              confirmButtonText: 'Fertig',
              timer: 1000
            })
          }
        }) */
    }
  }
}
</script>
<style scoped>
    .underline {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/SalesOrder/SalesLine.vue